import { http } from '../http'
import { URL } from './_constant'

/**
 * 集体土地项目-资金监审-列表
 */
export function API_FUND_AUDIT_LIST(data?: BasicPageReq) {
  return http.post<ApiFundAudit.ListRes>(URL.LIST, data)
}

/**
 * 集体土地项目-资金监审-全部
 */
export function API_FUND_AUDIT_ALL(data?: BasicPageReq) {
  return http.post<ApiFundAudit.Item[]>(URL.LIST, data)
}

/**
 * 集体土地项目-资金监审-详情
 */
export function API_FUND_AUDIT_DETAIL(id: string) {
  return http.post<ApiFundAudit.Item>(URL.DETAIL, { id })
}

/**
 * 集体土地项目-资金监审-新增
 */
export function API_FUND_AUDIT_ADD(data: ApiFundAudit.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 集体土地项目-资金监审-删除
 */
export function API_FUND_AUDIT_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  集体土地项目-资金监审-编辑
 */
export function API_FUND_AUDIT_EDIT(data: BasicUpdateOneReq<ApiFundAudit.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  集体土地项目-资金监审-禁用
 */
export function API_FUND_AUDIT_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 集体土地项目-资金监审-启用
 */
export function API_FUND_AUDIT_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 集体土地项目-资金监审-排序
 */
export function API_FUND_AUDIT_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}

/**
 * 集体土地项目-资金监审-审核列表
 */
export function API_FUND_AUDIT_REVIEW_LIST(data?: BasicPageReq) {
  return http.post<ApiFundAudit.ListRes>(URL.REVIEW_LIST, data)
}

/**
 * 集体土地项目-资金监审-资金监审名单导入模板下载
 */
export function API_FUND_AUDIT_USER_FILE_TPL() {
  return http.post<ImportTemplateRes>(URL.USER_FILE_TPL)
}

/**
 * 集体土地项目-资金监审-资金监审名单文件预览
 */
export function API_FUND_AUDIT_USER_FILE_PREVIEW(data: ApiFundAudit.UserFilePreviewReq) {
  return http.post(URL.USER_FILE_PREVIEW, data)
}
